let mainPath = "/deliveries";
let viewFolder = "Delivery";

module.exports = [
    {
        path: mainPath+'/view/:id',
        name: 'Delivery',
        component: () => import('../views/'+viewFolder+'/View.vue'),
    }
]